if (process.env.REACT_APP_ENVIRONMENT === undefined) {
  throw new Error("Please define REACT_APP_ENVIRONMENT in .env file");
}
if (process.env.REACT_APP_COMMENT_BACKEND_URL === undefined) {
  throw new Error("Please define COMMENT_BACKEND_URL in .env file");
}
export const BACKEND_URL = process.env.REACT_APP_COMMENT_BACKEND_URL;
export const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;
export const WRITE_URL = process.env.REACT_APP_WRITE_API_URL;
